import React from 'react';
import DeviceCasePreselectionDiagnoseDetailsBattery from './components/DeviceCasePreselectionDiagnoseDetailsBattery';
import DeviceCasePreselectionDiagnoseDetailsMotherboard from "./components/DeviceCasePreselectionDiagnoseDetailsMotherboard";
import DeviceCasePreselectionDiagnoseDetailsKeyboard from "./components/DeviceCasePreselectionDiagnoseDetailsKeyboard";
import DeviceCasePreselectionDiagnoseDetailsLiveCall from "./components/DeviceCasePreselectionDiagnoseDetailsLiveCall";
import DeviceCasePreselectionDiagnoseDetailsBatteryDischarge from "./components/DeviceCasePreselectionDiagnoseDetailsBatteryDischarge";
import DeviceCasePreselectionDiagnoseDetailsDriveHealth from "./components/DeviceCasePreselectionDiagnoseDetailsDriveHealth";

function DeviceCasePreselectionDiagnoseDetails(props) {
    const Key = props.location.state?.redirectOptions?.rowData?.Key;
    switch (Key) {
        case 'motherboard':
            return <DeviceCasePreselectionDiagnoseDetailsMotherboard {...props} />;
        case 'battery_capacity':
            return <DeviceCasePreselectionDiagnoseDetailsBattery {...props} />;
        case 'keyboard':
            return <DeviceCasePreselectionDiagnoseDetailsKeyboard {...props} />;
        case 'livecall':
            return <DeviceCasePreselectionDiagnoseDetailsLiveCall {...props} />;
        case 'battery_discharge':
            return ['mobile', 'headphone'].includes(props.location.state?.redirectOptions?.rowData?.ProductType) ? <DeviceCasePreselectionDiagnoseDetailsBatteryDischarge {...props} /> : null;
        case 'drive_health':
            return <DeviceCasePreselectionDiagnoseDetailsDriveHealth {...props} />;
        default:
            return null;
    }

}

export default DeviceCasePreselectionDiagnoseDetails
